import { useState, useEffect } from 'react';
import { getUserInfo } from './auth';

const useAuth = () => {
  const [user, setUser] = useState(null);
  const [userLoading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const fetchUser = async () => {
      try {
        const data = await getUserInfo();
        setUser(data.user);
      } catch (error) {
        console.error('Authentication error:', error);
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      fetchUser();
    } else {
      setLoading(false);
    }
  }, []);

  return { user, userLoading };
};

export default useAuth;